import { request } from '@/shared/api/request'

export const sendGrants = (body) => request({ url: `admin/sendGrants`, method: 'POST', data: body })